export const DEFAULT_QUERY_SETTINGS = {
  cacheTime: 1440 * 60 * 1000,
  staleTime: Infinity,
  retry: false,
  refetchOnWindowFocus: false,
}

export const BASE_PATH = '/iam-new'
